import { List, SignOut, X } from 'phosphor-react';

function Sidebar({
  navItems,
  activeView,
  setActiveView,
  isSidebarOpen,
  setIsSidebarOpen,
  profileMenuRef,
  isProfileMenuOpen,
  setIsProfileMenuOpen,
  profileInitial,
  profileName,
  onSignOut
}) {
  return (
    <>
      <button
        type="button"
        className="fixed left-4 top-4 z-50 inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 shadow lg:hidden"
        onClick={() => setIsSidebarOpen(true)}
        aria-label="Open menu"
      >
        <List size={18} weight="bold" />
      </button>

      <div
        className={`fixed inset-0 z-40 bg-slate-900/40 transition-opacity lg:hidden ${
          isSidebarOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={() => setIsSidebarOpen(false)}
      />

      <aside
        className={`fixed left-0 top-0 z-50 flex h-screen w-72 flex-col border-r border-slate-200 bg-white p-4 transition-transform duration-200 lg:sticky lg:top-0 lg:translate-x-0 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="mb-6 flex items-center justify-between">
          <img src="/logo/logo-full.png" alt="euz-lab" className="h-9 w-auto object-contain" />
          <button
            type="button"
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-700 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Close menu"
          >
            <X size={16} weight="bold" />
          </button>
        </div>

        <nav className="grid gap-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeView === item.key;
            return (
              <button
                key={item.key}
                type="button"
                onClick={() => {
                  setActiveView(item.key);
                  setIsSidebarOpen(false);
                }}
                className={`inline-flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-semibold transition ${
                  isActive ? 'bg-brand-100 text-brand-800' : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                <Icon size={18} weight="bold" />
                {item.label}
              </button>
            );
          })}
        </nav>

        <div className="relative mt-auto pt-4" ref={profileMenuRef}>
          <div
            className={`absolute bottom-full left-0 right-0 mb-2 origin-bottom overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg transition-all ${
              isProfileMenuOpen
                ? 'pointer-events-auto max-h-20 translate-y-0 opacity-100'
                : 'pointer-events-none max-h-0 translate-y-1 opacity-0'
            }`}
          >
            <button
              type="button"
              onClick={onSignOut}
              className="inline-flex w-full items-center gap-2 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
            >
              <SignOut size={15} weight="bold" />
              Sign out
            </button>
          </div>
          <button
            type="button"
            onClick={() => setIsProfileMenuOpen((prev) => !prev)}
            className="inline-flex w-full items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-left"
          >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-slate-900 text-sm font-bold text-white">
              {profileInitial}
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-semibold text-slate-800">{profileName}</span>
              <span className="block text-xs text-slate-500">user</span>
            </span>
          </button>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
